/**
 * WhatsApp Migration API Schemas
 */

import { z } from "zod";

export const WhatsAppMigrationRecordSchema = z.object({
  id: z.string(),
  senderId: z.string(),
  senderName: z.string(),
  connectionId: z.string(),
  phoneNumber: z.string(),
  phoneNumberId: z.string(),
  currentWebhookUrl: z.string(),
  expectedWebhookUrl: z.string(),
  webhookStatus: z.enum(["synced", "not_synced", "check_failed"]),
  error: z.string().nullable()
});

export const WhatsAppMigrationStatusResponseSchema = z.object({
  total: z.number(),
  webhookSynced: z.number(),
  webhookNotSynced: z.number(),
  webhookCheckFailed: z.number(),
  senders: z.array(WhatsAppMigrationRecordSchema)
});

export const MigrateWhatsAppWebhookBodySchema = z.object({
  senderId: z.string().min(1)
});

export const MigrateWhatsAppWebhookResponseSchema = z.object({
  success: z.boolean(),
  senderId: z.string(),
  senderName: z.string(),
  phoneNumber: z.string(),
  phoneNumberId: z.string(),
  webhookUrl: z.string().optional(),
  error: z.string().optional()
});
